import { render, staticRenderFns } from "./projectChoose.vue?vue&type=template&id=1c156470&scoped=true"
import script from "./projectChoose.vue?vue&type=script&lang=js"
export * from "./projectChoose.vue?vue&type=script&lang=js"
import style0 from "./projectChoose.vue?vue&type=style&index=0&id=1c156470&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c156470",
  null
  
)

export default component.exports